import { observer } from 'mobx-react';
import ParticipantsStore from '../../../../ParticipantsStore';
import { Link } from '../../../../Resource/Types';
import GenericSideLoadFilter from '../GenericSideLoadFilter';

interface Props {
  link: Link;
  participantsStore: ParticipantsStore;
}

function ProgramsFilter({ link, participantsStore }: Props) {
  return (
    <GenericSideLoadFilter
      link={link}
      updatingSearchParameters={participantsStore.updatingSearchParameters}
      searchParameters={participantsStore.searchParameters}
      labelText="Program"
      filterKey="program"
    />
  );
}

export default observer(ProgramsFilter);
